<template>
  <el-dialog
    :title="`${isEdit ? '编辑' : '新增'}渠道进度`"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
    width="600px"
    @close="onBeforeClose"
    @opened="opened"
  >
    <el-form ref="form" :model="form" :rules="rules" v-loading="loading">
      <el-form-item label="渠道" prop="id">
          <el-select
          v-model="form.id"
          filterable
          remote
          reserve-keyword
          placeholder="请输入渠道名搜索"
          :remote-method="remoteMethod">
          <el-option
            v-for="item in nameOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标合作内容" prop="remark">
          <el-input v-model="form.remark" placeholder=""></el-input>
        </el-form-item>
      <el-form-item label="目标上线时间" prop="mubiaotime">
        <el-date-picker v-model="form.mubiaotime" align="right" type="date" placeholder="选择日期" format='yyyy-MM-dd' value-format='yyyy-MM-dd' :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>
      <el-form-item label="负责人" prop="responsor">
          <el-input v-model="form.responsor" placeholder="请输入负责人"></el-input>
        </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="$emit('input', null)">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      isEdit: false,
      loading: false,
      visible: false,
      nameOptions: [],
      form: {
        system: 'changjing'
      },
      rules: {
        id: { required: true, message: '请输入渠道' },
        remark: { required: true, message: '请输入目标内容', trigger: 'blur' },
        mubiaotime: { required: true, message: '请选择目标上线时间', trigger: 'change' },
        responsor: { required: true, message: '请输入负责人', trigger: 'blur' }
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周后',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }, {
          text: '半个月后',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 15)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  watch: {
    value (val) {
      this.visible = !!val
      this.isEdit = val && val.zhiwei_id
      this.isEdit && (this.loading = true)
    }
  },
  methods: {
    remoteMethod(name) {
      if (name !== '') {
        this.$http.post('/changjing/list', { name }).then(res => {
          this.nameOptions = res.data.data
        })
      } else {
        this.nameOptions = []
      }
    },
    opened () {
      if (this.isEdit) {
        const form = JSON.parse(JSON.stringify(this.value))
        this.form = form
        this.loading = false
      }
    },
    onBeforeClose () {
      this.$refs.form.resetFields()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          // 提交时间
          const params1 = JSON.parse(JSON.stringify(this.form))
          params1.name = 'mubiaotime'
          params1.time = params1.mubiaotime
          delete params1.mubiaotime
          // 提交负责人
          const params2 = JSON.parse(JSON.stringify(this.form))
          params2.name = 'responsor'
          delete params2.mubiaotime
          delete params2.remark
          // 提交目标内容
          const params3 = JSON.parse(JSON.stringify(this.form))
          params3.name = 'remark'
          delete params3.responsor
          delete params3.mubiaotime
          Promise.all([
            this.$http.post('/projecttime/add', params1),
            this.$http.post('/projecttime/add', params2),
            this.$http.post('/projecttime/add', params3)
          ]).then(res => {
            if (res[0].successful) {
              this.$emit('input', null)
              this.$parent.$refs.table.reload()
            }
            this.loading = false
          })
          // this.$http.post('/projecttime/add', params).then(res => {
          //   if (res.successful) {
          //     this.$emit('input', null)
          //     this.$parent.$refs.table.reload()
          //   }
          //   this.loading = false
          // })
        }
      })
    }
  }
}
</script>
